<button class="alertBtn" appOpenAlertPopin [configCatalog]="configCatalog" [product]="product">
  <vc-sprite-icons class="alertBtn__icon test" name="bell"></vc-sprite-icons>
  <span i18n="@@ALERT.BTN_CREATE">Create an alert</span>
</button>
